import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;

export function unset(cell: api_cs.Ccells): void {
	switch (cell.properties.type.state.name) {
		case "text": {
			const type = cell.properties.type.state.node;
			type.properties.is_set.set("no", {});
			break;
		}
		case "file": {
			const type = cell.properties.type.state.node;
			type.properties.is_set.set("no", {});
			break;
		}
		case "number": {
			const type = cell.properties.type.state.node;
			type.properties.is_set.set("no", {});
			break;
		}
		case "state group": {
			const type = cell.properties.type.state.node;
			type.properties.is_set.set("no", {});
			break;
		}
		case "widget":
			break;
		default:
			unexpectedState(cell.properties.type.state);
	}
}

export function updateText(text_cell: api_cs.Ctext__type__cells, value: string): void {
	switch (text_cell.properties.is_set.state.name) {
		case "yes": {
			const cell_is_set = text_cell.properties.is_set.state.node;
			if (cell_is_set.properties.text !== value) {
				cell_is_set.set_text(value);
			}
			break;
		}
		case "no":
			text_cell.properties.is_set.set("yes", { text: value });
			break;
		default:
			unexpectedState(text_cell.properties.is_set.state);
	}
}

export function updateNumber(
	number_cell: api_cs.Cnumber__type__cells,
	value: number,
	textual_representation: string
): void {
	switch (number_cell.properties.is_set.state.name) {
		case "yes": {
			const cell_is_set = number_cell.properties.is_set.state.node;
			if (cell_is_set.properties.number.value !== value) {
				cell_is_set.set_number(value);
				cell_is_set.set_textual_representation(textual_representation);
			}
			break;
		}
		case "no":
			number_cell.properties.is_set.set("yes", {
				number: value,
				"textual representation": textual_representation,
			});
			break;
		default:
			unexpectedState(number_cell.properties.is_set.state);
	}
}

export function updateFile(file_cell: api_cs.Cfile__type__cells, token: string, extension: string): void {
	switch (file_cell.properties.is_set.state.name) {
		case "yes": {
			const target_is_set = file_cell.properties.is_set.state.node;
			if (target_is_set.properties.token !== token) {
				target_is_set.set_token(token);
			}
			if (target_is_set.properties.extension !== extension) {
				target_is_set.set_extension(extension);
			}
			break;
		}
		case "no":
			file_cell.properties.is_set.set("yes", {
				token: token,
				extension: extension,
			});
			break;
		default:
			unexpectedState(file_cell.properties.is_set.state);
	}
}

export function updateStategroup(stategroup_cell: api_cs.Cstate_group__type__cells, state: string): void {
	switch (stategroup_cell.properties.is_set.state.name) {
		case "yes": {
			const cell_is_set = stategroup_cell.properties.is_set.state.node;
			if (cell_is_set.properties.state !== state) {
				cell_is_set.set_state(state);
			}
			break;
		}
		case "no":
			stategroup_cell.properties.is_set.set("yes", {
				state: state,
				style: { initialized: ["no", {}] },
			});
			break;
		default:
			unexpectedState(stategroup_cell.properties.is_set.state);
	}
}
